import { Center, PresentationControls, Float,Environment, useGLTF, OrbitControls } from '@react-three/drei'
import { Html,Text,ContactShadows } from '@react-three/drei'
import { Leva, useControls } from 'leva' 

export default function Experience()
{

    const model =  useGLTF('https://vazxmixjsiawhamofees.supabase.co/storage/v1/object/public/models/macbook/model.gltf')

    return <>
       

        <Environment preset='dawn' />

        <color args={['#28282B']} attach="background" />

    
    <PresentationControls 
        // global
        // rotation={[0.13,0.1,0]}
        // polar={[-0.4,0.2]}
        // azimuth={[-0.75,0.75]}
        // config={{mass: 2, tension: 400}}
        // snap={{mass: 4, tension: 400}}
        global
            rotation={ [ 0.13, 0.1, 0 ] }
            polar={ [ - 0.4, 0.2 ] }
            azimuth={ [ - 1, 0.75 ] }
            config={ { mass: 2, tension: 400 } }
            snap={ { mass: 4, tension: 400 } }
    >
        <Float rotationIntensity={ 0.4 }>
        <rectAreaLight
                    width={ 2.5 }
                    height={ 1.65 }
                    intensity={ 25 }
                    color={ '#00CED1' }
                    rotation={ [ - 0.1, Math.PI, 0 ] }
                    position={ [ 0, 0.55, - 1.15 ] }
                />
            <primitive
            // rotation-y={Math.PI }
            scale={[1.1,1.1,1.1]}
            object={ model.scene }
            position-y={ - 1.2 }
            
            >
            <Html
                
                wrapperClass='screen'
                
                transform
                // style= {{ transform: 'scaleX(-1)'}}
                distanceFactor={2.3}
                position={[0,1.56,-1.4]}
                rotation-x = {-0.256}
                // wrapperClass="screen"
                //         distanceFactor={ 1 }
                //         position={ [ 0.2, 0,  1.7 ] }
                //         rotation-x={  0.256 }
                
                
            >
                <iframe src="https://2dportfolio-nine.vercel.app"/>
                </Html>
                </primitive>
                <Text
                    font="./Audiowide/Audiowide-Regular.ttf"
                    fontSize={ 0.6 }
                    fontWeight="bold"
                    position={ [ 2, 0.75, 0.75 ] }
                    rotation-y={ - 1.5 }
                    maxWidth={ 2 }
                    color="grey"                >
                    Welcome Aboard!
                </Text>
                
            
        </Float>
    </PresentationControls>
    <ContactShadows
        position-y={-1.4}
        opacity={0.5}
        scale={5}
        blur={2.5}
    ></ContactShadows>
    </>
}